"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcInputSelectV2Behavior = void 0;
var default_behavior_1 = require("../../../common/models/default-behavior");
var common_constants_1 = require("../../../common/constants/common-constants");
var bc_float_menu_behavior_1 = require("../../organisms/bc-float-menu/bc-float-menu-behavior");
var bc_input_select_v2_constants_1 = require("./bc-input-select-v2-constants");
var BcInputSelectV2Behavior = (function (_super) {
    __extends(BcInputSelectV2Behavior, _super);
    function BcInputSelectV2Behavior() {
        return _super.call(this) || this;
    }
    BcInputSelectV2Behavior.prototype._setUp = function () {
        _super.prototype._setUp.call(this);
        this.setSettings();
        this.addMainClass();
        this.buildSelect();
        this.setStatus(this.status);
        this.setAriaLabel();
    };
    BcInputSelectV2Behavior.prototype.getAttributeHTML = function (attributeName, defaultValue) {
        var attribute = this.mySelf.getAttribute(attributeName);
        return attribute ? attribute : defaultValue;
    };
    BcInputSelectV2Behavior.prototype.setSettings = function () {
        if (!this.type) {
            this.type = this.getAttributeHTML('type', 'simple');
        }
        if (!this.label) {
            this.label = this.getAttributeHTML('label', null);
        }
        if (!this.iconName) {
            this.iconName = this.getAttributeHTML('iconName', null);
        }
        if (!this.status) {
            this.status = this.getAttributeHTML('status', 'default');
        }
        if (!this.helpText) {
            this.helpText = this.getAttributeHTML('helptext', null);
        }
        if (!this.initialValue) {
            this.initialValue = this.getAttributeHTML('initialValue', '');
        }
    };
    BcInputSelectV2Behavior.prototype.addMainClass = function () {
        this.mySelf.classList.add(bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_INPUT_SELECT_V2);
    };
    BcInputSelectV2Behavior.prototype.setAriaLabel = function () {
        if (!this.ariaLabel) {
            this.ariaLabel = this.getAttributeHTML('aria-label', '');
        }
        if (this.ariaLabel && this.ariaLabel != '') {
            this.mySelf.removeAttribute('aria-label');
            var placeholder = this.mySelf.querySelector(".".concat(bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_INPUT_SELECT_V2_PLACEHOLDER));
            placeholder.setAttribute('aria-label', this.ariaLabel);
        }
    };
    BcInputSelectV2Behavior.prototype.deleteAllElements = function () {
        Array.from(this.mySelf.children).forEach(function (child) { return child.remove(); });
    };
    BcInputSelectV2Behavior.prototype.buildSelect = function () {
        this.deleteAllElements();
        if (this.type === 'multiple') {
            this.buildMultipleSelect();
        }
        else {
            this.buildSimpleSelect();
        }
    };
    BcInputSelectV2Behavior.prototype.buildSimpleSelect = function () {
        this.mySelf.classList.add(bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_INPUT_SELECT_V2_SIMPLE);
        var idLabel = this.createLabel();
        this.createPlaceholder(idLabel);
        this.createItemsFloatMenu();
        this.createHelptext();
        this.setupFloatMenu();
        this.addToggleListener();
        this.addWindowListener();
        this.setAccessibility(idLabel);
    };
    BcInputSelectV2Behavior.prototype.buildMultipleSelect = function () {
        this.mySelf.classList.add(bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_INPUT_SELECT_V2_MULTIPLE);
        var idLabel = this.createLabel();
        this.createPlaceholder(idLabel);
        this.createItemsFloatMenu();
        this.createHelptext();
        this.setupFloatMenu();
        this.addToggleListener();
        this.addWindowListener();
        this.setAccessibility(idLabel);
    };
    BcInputSelectV2Behavior.prototype.setAccessibility = function (idLabel) {
        var listBox = this.mySelf.querySelector(".".concat(bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_FLOAT_MENU_CONTENT, " ul"));
        listBox.setAttribute('role', 'listbox');
        listBox.setAttribute('aria-labelledby', idLabel);
        var options = this.mySelf.querySelectorAll(".".concat(bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_FLOAT_MENU_OPTION));
        options.forEach(function (option) {
            option.setAttribute('role', 'option');
        });
    };
    BcInputSelectV2Behavior.prototype.addWindowListener = function () {
        var _this = this;
        window.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
            setTimeout(function () {
                var isFloatMenuClosed = _this.mySelf.querySelector(".".concat(bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_FLOAT_MENU_CONTENT_ACTIVE)) === null;
                if (isFloatMenuClosed) {
                    _this.changeArrowIcon(common_constants_1.BcCommonConstants.ICON_ARROW_DOWN);
                    var textSelectedElement = _this.mySelf.querySelector(".".concat(bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_INPUT_SELECT_V2_PLACEHOLDER_TEXT));
                    var textSelected = textSelectedElement.textContent;
                    if (textSelected === '') {
                        _this.setClassFilled(false);
                    }
                }
            });
        });
    };
    BcInputSelectV2Behavior.prototype.createLabel = function () {
        if (this.label) {
            var spanLabel = document.createElement('span');
            spanLabel.textContent = this.label;
            spanLabel.classList.add(bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_INPUT_SELECT_V2_LABEL, bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_FLOAT_MENU_TOGGLE);
            var labelId = this.generateId('span');
            spanLabel.setAttribute('id', labelId);
            this.mySelf.append(spanLabel);
            return labelId;
        }
        return '';
    };
    BcInputSelectV2Behavior.prototype.createHelptext = function () {
        if (this.helpText) {
            var spanHelptext = document.createElement('span');
            spanHelptext.classList.add(bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_INPUT_SELECT_V2_HELPTEXT);
            spanHelptext.textContent = this.helpText;
            this.mySelf.append(spanHelptext);
        }
    };
    BcInputSelectV2Behavior.prototype.setupFloatMenu = function () {
        var floatMenuElement = this.mySelf.querySelector(".".concat(bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_FLOAT_MENU));
        var bcFloatMenuBehavior = new bc_float_menu_behavior_1.BcFloatMenuBehavior();
        bcFloatMenuBehavior.setElement(floatMenuElement);
        bcFloatMenuBehavior.setUp();
    };
    BcInputSelectV2Behavior.prototype.changeArrowIcon = function (arrowIcon) {
        var iconTag = this.mySelf.getElementsByClassName(bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_FLOAT_MENU_TOGGLE_ICON)[0];
        iconTag.textContent = arrowIcon;
    };
    BcInputSelectV2Behavior.prototype.setClassFilled = function (addAction) {
        if (addAction) {
            this.mySelf.classList.add(bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_INPUT_SELECT_V2_FILLED);
        }
        else {
            this.mySelf.classList.remove(bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_INPUT_SELECT_V2_FILLED);
        }
    };
    BcInputSelectV2Behavior.prototype.clearSelectedOption = function (removeClass, removeChecked) {
        var _this = this;
        var options = this.mySelf.querySelectorAll(".".concat(bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_FLOAT_MENU_OPTION));
        options.forEach(function (option) {
            option.setAttribute('aria-selected', 'false');
            if (removeClass) {
                option.classList.remove(bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_FLOAT_MENU_OPTION_SELECTED);
            }
            if (_this.type === 'multiple' && removeChecked) {
                var inputCheckbox = option.querySelector('.bc-float-menu-input');
                if (inputCheckbox) {
                    inputCheckbox.removeAttribute('checked');
                    inputCheckbox.checked = false;
                }
            }
        });
    };
    BcInputSelectV2Behavior.prototype.preventOnSpace = function (event) {
        if (event.code === common_constants_1.BcCommonConstants.KEY_EVENT_SPACE) {
            event.preventDefault();
        }
    };
    BcInputSelectV2Behavior.prototype.handleFloatMenuOnKeyboard = function (event) {
        var _this = this;
        var allowedKeyCodes = [
            common_constants_1.BcCommonConstants.KEY_EVENT_ENTER,
            common_constants_1.BcCommonConstants.KEY_EVENT_SPACE,
            common_constants_1.BcCommonConstants.KEY_EVENT_ESCAPE,
        ];
        if (allowedKeyCodes.includes(event.code)) {
            if (event.code === common_constants_1.BcCommonConstants.KEY_EVENT_ESCAPE) {
                var isFloatMenuOpen = this.mySelf.getElementsByClassName(bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_FLOAT_MENU_CONTENT_ACTIVE).length > 0;
                if (isFloatMenuOpen) {
                    var placeholderElement = this.mySelf.querySelector(".".concat(bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_INPUT_SELECT_V2_PLACEHOLDER));
                    placeholderElement.dispatchEvent(new MouseEvent(common_constants_1.BcCommonConstants.EVENT_MOUSEDOWN));
                }
            }
            setTimeout(function () {
                _this.handleFloatMenuOnClick();
            });
        }
    };
    BcInputSelectV2Behavior.prototype.handleFloatMenuOnKeydown = function (event) {
        if (event.code === common_constants_1.BcCommonConstants.KEY_EVENT_ARROW_DOWN) {
            event.preventDefault();
            var placeholderElement = this.mySelf.querySelector(".".concat(bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_INPUT_SELECT_V2_PLACEHOLDER));
            placeholderElement.dispatchEvent(new MouseEvent(common_constants_1.BcCommonConstants.EVENT_MOUSEDOWN));
            var firstOption = this.mySelf.querySelector(".".concat(bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_FLOAT_MENU_OPTION));
            firstOption.focus();
            this.handleFloatMenuOnClick();
        }
        this.preventOnSpace(event);
    };
    BcInputSelectV2Behavior.prototype.handleFloatMenuOnClick = function () {
        var isFloatMenuOpen = this.mySelf.getElementsByClassName(bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_FLOAT_MENU_CONTENT_ACTIVE).length > 0;
        this.changeArrowIcon(isFloatMenuOpen ? common_constants_1.BcCommonConstants.ICON_ARROW_UP : common_constants_1.BcCommonConstants.ICON_ARROW_DOWN);
        if (this.selectedOptionValue) {
            this.setClassFilled(true);
        }
        else {
            this.setClassFilled(isFloatMenuOpen);
        }
        if (isFloatMenuOpen) {
            var sectionPlaceholder = this.mySelf.querySelector(".".concat(bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_INPUT_SELECT_V2_PLACEHOLDER));
            sectionPlaceholder.setAttribute('aria-expanded', 'true');
            var listBox = this.mySelf.querySelector(".".concat(bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_FLOAT_MENU_CONTENT, "-active ul"));
            listBox.setAttribute('aria-expanded', 'true');
        }
        else {
            var sectionPlaceholder = this.mySelf.querySelector(".".concat(bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_INPUT_SELECT_V2_PLACEHOLDER));
            sectionPlaceholder.setAttribute('aria-expanded', 'false');
            var listBox = this.mySelf.querySelector(".".concat(bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_FLOAT_MENU_CONTENT, " ul"));
            listBox.setAttribute('aria-expanded', 'false');
        }
    };
    BcInputSelectV2Behavior.prototype.addToggleListener = function () {
        var _this = this;
        var dropdown = this.mySelf.querySelector(".".concat(bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_INPUT_SELECT_V2_PLACEHOLDER));
        dropdown.addEventListener('click', function () { return _this.handleFloatMenuOnClick(); });
        dropdown.addEventListener('keyup', function (event) { return _this.handleFloatMenuOnKeyboard(event); });
        dropdown.addEventListener('keydown', function (event) { return _this.handleFloatMenuOnKeydown(event); });
    };
    BcInputSelectV2Behavior.prototype.createIcon = function (icon, tagElement) {
        var bcIcon = document.createElement(tagElement);
        bcIcon.classList.add('bc-icon', 'bc-sm');
        bcIcon.setAttribute('role', 'img');
        bcIcon.setAttribute('aria-hidden', 'true');
        bcIcon.textContent = icon;
        return bcIcon;
    };
    BcInputSelectV2Behavior.prototype.generateId = function (typeTag) {
        var prefix = "bc-input-select-v2-".concat(typeTag);
        var array = new Uint32Array(1);
        var randomNumber = window.crypto.getRandomValues(array);
        return "".concat(prefix, "-").concat(randomNumber[0]);
    };
    BcInputSelectV2Behavior.prototype.createSectionPlaceholder = function (idLabel) {
        var sectionPlaceholder = document.createElement('section');
        sectionPlaceholder.classList.add(bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_FLOAT_MENU_TOGGLE, bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_INPUT_SELECT_V2_PLACEHOLDER, bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_INPUT_SELECT);
        sectionPlaceholder.setAttribute('role', 'combobox');
        sectionPlaceholder.setAttribute('aria-haspopup', 'listbox');
        sectionPlaceholder.setAttribute('aria-expanded', 'false');
        if (idLabel !== '') {
            sectionPlaceholder.setAttribute('aria-labelledby', idLabel);
        }
        return sectionPlaceholder;
    };
    BcInputSelectV2Behavior.prototype.createInputPlaceholder = function () {
        var inputId = this.generateId('input');
        var inputText = document.createElement('span');
        inputText.setAttribute('id', inputId);
        inputText.classList.add(bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_INPUT_SELECT_V2_PLACEHOLDER_TEXT, bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_FLOAT_MENU_TOGGLE, 'bc-input');
        return inputText;
    };
    BcInputSelectV2Behavior.prototype.createMainIcon = function () {
        var iconCustom = this.createIcon(this.iconName, 'i');
        iconCustom.classList.add(bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_INPUT_SELECT_V2_PLACEHOLDER_ICON, bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_FLOAT_MENU_TOGGLE);
        return iconCustom;
    };
    BcInputSelectV2Behavior.prototype.createPlaceholder = function (idLabel) {
        var sectionPlaceholder = this.createSectionPlaceholder(idLabel);
        var divSelect = document.createElement('div');
        divSelect.classList.add(bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_INPUT_SELECT_V2_COMBOBOX, bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_FLOAT_MENU_TOGGLE);
        if (this.iconName) {
            var mainIcon = this.createMainIcon();
            divSelect.appendChild(mainIcon);
            this.mySelf.classList.add(bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_INPUT_SELECT_V2_ICON);
        }
        var inputText = this.createInputPlaceholder();
        divSelect.appendChild(inputText);
        var iconArrow = this.createIcon('arrow2-down', 'i');
        iconArrow.classList.add(bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_FLOAT_MENU_TOGGLE_ICON);
        divSelect.appendChild(iconArrow);
        sectionPlaceholder.appendChild(divSelect);
        var divDropdown = document.createElement('div');
        divDropdown.classList.add(bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_INPUT_SELECT_V2_DROPDOWN);
        divDropdown.appendChild(sectionPlaceholder);
        this.mySelf.append(divDropdown);
    };
    BcInputSelectV2Behavior.prototype.createLiOptionElement = function (dataValue) {
        var liOption = document.createElement('li');
        liOption.classList.add(bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_FLOAT_MENU_OPTION);
        liOption.setAttribute('role', 'option');
        liOption.setAttribute('data-value', dataValue);
        return liOption;
    };
    BcInputSelectV2Behavior.prototype.createSpanTextOption = function (className, textContent) {
        var spanText = document.createElement('span');
        spanText.classList.add(className);
        spanText.textContent = textContent;
        return spanText;
    };
    BcInputSelectV2Behavior.prototype.createOptionPreloader = function () {
        var _a;
        var liOption = document.createElement('li');
        liOption.classList.add(bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_FLOAT_MENU_OPTION);
        liOption.setAttribute('role', 'option');
        var divPreloader = document.createElement('div');
        (_a = divPreloader.classList).add.apply(_a, bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_PRELOADER_CLASSES);
        divPreloader.setAttribute('width', 'full');
        liOption.appendChild(divPreloader);
        return liOption;
    };
    BcInputSelectV2Behavior.prototype.createSimpleOption = function (element) {
        var liOption = this.createLiOptionElement(element.value);
        if (element.icon) {
            var iconCustom = this.createIcon(element.icon, 'em');
            liOption.appendChild(iconCustom);
        }
        var linkElement = document.createElement('a');
        var spanText = this.createSpanTextOption(bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_FLOAT_MENU_MAIN_TEXT, element.label);
        linkElement.appendChild(spanText);
        if (element.subtitle) {
            var spanSubtitle = this.createSpanTextOption('bc-float-menu-secondary-text', element.subtitle);
            linkElement.appendChild(spanSubtitle);
        }
        liOption.appendChild(linkElement);
        var itemSelected = element.selected && element.selected === true;
        var isInitialValueSelected = element.value == this.initialValue;
        if (itemSelected || isInitialValueSelected) {
            liOption.classList.add(bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_FLOAT_MENU_OPTION_SELECTED);
            liOption.setAttribute('aria-selected', 'true');
            this.changeValueSelected(element.label, element.value);
            this.setClassFilled(true);
        }
        else {
            liOption.setAttribute('aria-selected', 'false');
        }
        return liOption;
    };
    BcInputSelectV2Behavior.prototype.createListOptions = function () {
        var _this = this;
        var ulElement = document.createElement('ul');
        ulElement.setAttribute('role', 'listbox');
        ulElement.setAttribute('aria-expanded', 'false');
        if (this.itemsFloatMenu) {
            this.itemsFloatMenu.forEach(function (element) {
                var liOption = _this.createSimpleOption(element);
                _this.addOptionsListener(liOption);
                ulElement.appendChild(liOption);
            });
        }
        else {
            var liPreloader = this.createOptionPreloader();
            ulElement.appendChild(liPreloader);
        }
        return ulElement;
    };
    BcInputSelectV2Behavior.prototype.createInputCheckOption = function () {
        var inputId = this.generateId('input');
        var inputCheckbox = document.createElement('input');
        inputCheckbox.setAttribute('id', inputId);
        inputCheckbox.setAttribute('type', 'checkbox');
        inputCheckbox.setAttribute('tabindex', '-1');
        inputCheckbox.classList.add('bc-float-menu-input');
        return inputCheckbox;
    };
    BcInputSelectV2Behavior.prototype.createDivCheckboxOption = function () {
        var divCheckbox = document.createElement('div');
        divCheckbox.classList.add('bc-float-menu-inputs');
        return divCheckbox;
    };
    BcInputSelectV2Behavior.prototype.createLabelCheckboxOption = function () {
        var labelCheckbox = document.createElement('label');
        labelCheckbox.classList.add('bc-container-checkbox');
        return labelCheckbox;
    };
    BcInputSelectV2Behavior.prototype.createLiOptionMultiple = function (element) {
        var liOption = this.createLiOptionElement(element.value);
        liOption.setAttribute('aria-selected', 'false');
        var divCheckbox = this.createDivCheckboxOption();
        var labelCheckbox = this.createLabelCheckboxOption();
        var inputCheckbox = this.createInputCheckOption();
        if (element.selected && element.selected === true) {
            liOption.classList.add(bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_FLOAT_MENU_OPTION_SELECTED);
            liOption.setAttribute('aria-pressed', 'true');
            liOption.setAttribute('aria-selected', 'true');
            inputCheckbox.setAttribute('checked', 'checked');
        }
        var spanCheckbox = document.createElement('span');
        spanCheckbox.classList.add('bc-checkbox');
        labelCheckbox.appendChild(inputCheckbox);
        labelCheckbox.appendChild(spanCheckbox);
        divCheckbox.appendChild(labelCheckbox);
        var linkElement = document.createElement('a');
        var spanText = this.createSpanTextOption(bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_FLOAT_MENU_MAIN_TEXT, element.label);
        linkElement.appendChild(spanText);
        liOption.appendChild(divCheckbox);
        liOption.appendChild(linkElement);
        return liOption;
    };
    BcInputSelectV2Behavior.prototype.createListCheckboxes = function () {
        var _this = this;
        var ulElement = document.createElement('ul');
        ulElement.setAttribute('role', 'listbox');
        var itemsSelected = [];
        if (this.itemsFloatMenu) {
            this.itemsFloatMenu.forEach(function (element) {
                var liOption = _this.createLiOptionMultiple(element);
                if (element.selected && element.selected === true) {
                    itemsSelected.push({ value: element.value, text: element.label });
                }
                _this.addOptionsListener(liOption);
                ulElement.appendChild(liOption);
            });
            if (itemsSelected.length > 0) {
                this.setClassFilled(true);
                this.changeTextSelectedMultiple(itemsSelected.length);
            }
        }
        else {
            var liPreloader = this.createOptionPreloader();
            ulElement.appendChild(liPreloader);
        }
        return ulElement;
    };
    BcInputSelectV2Behavior.prototype.createItemsFloatMenu = function () {
        var divContainerMenu = document.createElement('div');
        divContainerMenu.classList.add(bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_FLOAT_MENU);
        var sectionMenu = document.createElement('section');
        sectionMenu.classList.add(bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_FLOAT_MENU_CONTENT);
        var options = this.type === 'multiple' ? this.createListCheckboxes() : this.createListOptions();
        sectionMenu.appendChild(options);
        divContainerMenu.appendChild(sectionMenu);
        var divDropdown = this.mySelf.querySelector(".".concat(bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_INPUT_SELECT_V2_DROPDOWN));
        divDropdown.appendChild(divContainerMenu);
    };
    BcInputSelectV2Behavior.prototype.addOptionsListener = function (liElement) {
        var _this = this;
        liElement.addEventListener('click', function (event) {
            if (_this.type === 'multiple') {
                _this.selectOptionFloatMenuMultiple(event);
            }
            else {
                _this.selectOptionFloatMenu(event);
            }
        });
        liElement.addEventListener('keyup', function (event) {
            if (event.code === common_constants_1.BcCommonConstants.KEY_EVENT_ENTER || event.code === common_constants_1.BcCommonConstants.KEY_EVENT_SPACE) {
                if (_this.type === 'multiple') {
                    _this.selectOptionFloatMenuMultiple(event);
                }
                else {
                    _this.selectOptionFloatMenu(event);
                }
            }
            if (event.code === common_constants_1.BcCommonConstants.KEY_EVENT_ESCAPE) {
                setTimeout(function () {
                    _this.handleFloatMenuOnClick();
                });
            }
        });
        liElement.addEventListener('keydown', function (event) {
            _this.preventOnSpace(event);
        });
    };
    BcInputSelectV2Behavior.prototype.changeValueSelected = function (text, value) {
        var textOptionSelected = this.mySelf.querySelector(".".concat(bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_INPUT_SELECT_V2_PLACEHOLDER_TEXT));
        textOptionSelected.textContent = text;
        this.selectedOptionValue = value;
    };
    BcInputSelectV2Behavior.prototype.changeTextSelectedMultiple = function (numItemsSelected) {
        if (numItemsSelected > 0) {
            var valueText = this.getTextSelectedMultiple(numItemsSelected);
            this.changeValueSelected(valueText, numItemsSelected);
        }
        else {
            this.changeValueSelected('', '');
        }
    };
    BcInputSelectV2Behavior.prototype.getObjectToReturn = function (text, value) {
        return {
            idElement: this.mySelf.id,
            value: value,
            text: text,
        };
    };
    BcInputSelectV2Behavior.prototype.getSelectedItems = function (elements) {
        var selectedElements = [];
        elements.forEach(function (element) {
            var spanText = element.querySelector(".".concat(bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_FLOAT_MENU_MAIN_TEXT));
            selectedElements.push({ value: element.getAttribute('data-value'), text: spanText.textContent });
        });
        var selectedValues = selectedElements.map(function (item) { return item.value; }).join(',');
        return [selectedElements, selectedValues];
    };
    BcInputSelectV2Behavior.prototype.getTextSelectedMultiple = function (number) {
        if (number === 1) {
            return bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_INPUT_SELECT_V2_ONE_ITEM_SELECTED_MESSAGE;
        }
        else {
            return "".concat(number, " ").concat(bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_INPUT_SELECT_V2_ITEMS_SELECTED_MESSAGE);
        }
    };
    BcInputSelectV2Behavior.prototype.getObjectToReturnMultiple = function (selectedElements, values) {
        return {
            idElement: this.mySelf.id,
            value: values,
            items: selectedElements,
        };
    };
    BcInputSelectV2Behavior.prototype.selectOptionFloatMenu = function (event) {
        this.clearSelectedOption(false, false);
        this.setClassFilled(true);
        var optionElement = event.currentTarget;
        optionElement.setAttribute('aria-selected', 'true');
        var valueSelected = optionElement.getAttribute('data-value');
        var spanText = optionElement.querySelector(".".concat(bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_FLOAT_MENU_MAIN_TEXT));
        var valueText = spanText.textContent;
        this.changeValueSelected(valueText, valueSelected);
        this.changeArrowIcon(common_constants_1.BcCommonConstants.ICON_ARROW_DOWN);
        this.outputFunction(this.getObjectToReturn(valueText, valueSelected));
    };
    BcInputSelectV2Behavior.prototype.selectOptionFloatMenuMultiple = function (event) {
        var _this = this;
        setTimeout(function () {
            _this.clearSelectedOption(false, false);
            _this.setClassFilled(true);
            var itemsSelected = _this.mySelf.querySelectorAll(".".concat(bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_FLOAT_MENU_OPTION_SELECTED));
            itemsSelected.forEach(function (element) {
                element.setAttribute('aria-selected', 'true');
            });
            var _a = _this.getSelectedItems(itemsSelected), objectItemsSelected = _a[0], valuesSelected = _a[1];
            _this.changeTextSelectedMultiple(itemsSelected.length);
            _this.changeArrowIcon(common_constants_1.BcCommonConstants.ICON_ARROW_DOWN);
            _this.outputFunction(_this.getObjectToReturnMultiple(objectItemsSelected, valuesSelected));
        });
    };
    BcInputSelectV2Behavior.prototype.clearStatus = function () {
        this.mySelf.classList.remove(bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_INPUT_SELECT_V2_DISABLED);
        this.mySelf.classList.remove(bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_INPUT_SELECT_V2_ERROR);
        var placeholder = this.mySelf.querySelector(".".concat(bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_INPUT_SELECT_V2_PLACEHOLDER));
        placeholder.setAttribute('tabindex', '0');
    };
    BcInputSelectV2Behavior.prototype.reset = function () {
        this.clearSelectedOption(true, true);
        this.setClassFilled(false);
        this.changeValueSelected('', '');
        this.setStatus('default');
    };
    BcInputSelectV2Behavior.prototype.changeValueSimple = function (newValue) {
        var optionSelected = this.mySelf.querySelector(".".concat(bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_FLOAT_MENU_OPTION, "[data-value=\"").concat(newValue, "\"]"));
        if (optionSelected) {
            optionSelected.classList.add(bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_FLOAT_MENU_OPTION_SELECTED);
            var spanText = optionSelected.querySelector(".".concat(bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_FLOAT_MENU_MAIN_TEXT));
            this.changeValueSelected(spanText.textContent, newValue);
            this.setClassFilled(true);
        }
    };
    BcInputSelectV2Behavior.prototype.changeValueMultiple = function (newValue) {
        var ids = newValue.split(',');
        var itemsSelected = [];
        if (ids.length > 0) {
            var options = this.mySelf.querySelectorAll(".".concat(bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_FLOAT_MENU_OPTION));
            options.forEach(function (option) {
                var valueOption = option.getAttribute('data-value');
                if (ids.includes(valueOption)) {
                    option.classList.add(bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_FLOAT_MENU_OPTION_SELECTED);
                    option.setAttribute('aria-pressed', 'true');
                    option.setAttribute('aria-selected', 'true');
                    var inputCheckbox = option.querySelector('.bc-float-menu-input');
                    inputCheckbox.setAttribute('checked', 'checked');
                    var spanText = option.querySelector(".".concat(bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_FLOAT_MENU_MAIN_TEXT));
                    itemsSelected.push({ value: valueOption, text: spanText.textContent });
                }
            });
            if (itemsSelected.length > 0) {
                this.setClassFilled(true);
                this.changeTextSelectedMultiple(itemsSelected.length);
            }
        }
    };
    BcInputSelectV2Behavior.prototype.updateListOptions = function () {
        var isFloatMenuOpen = this.mySelf.querySelector(".".concat(bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_FLOAT_MENU_CONTENT_ACTIVE)) !== null;
        if (isFloatMenuOpen) {
            var clickEvent = new MouseEvent('click', { bubbles: true, cancelable: true, view: window });
            window.dispatchEvent(clickEvent);
        }
        var divContainerMenu = this.getMySelf().querySelector(".".concat(bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_FLOAT_MENU));
        divContainerMenu.remove();
        this.createItemsFloatMenu();
        this.setupFloatMenu();
    };
    BcInputSelectV2Behavior.prototype.setItems = function (items) {
        var isValid = items.length > 0 && items.every(function (item) { return 'label' in item && 'value' in item; });
        if (isValid) {
            this.itemsFloatMenu = items;
        }
    };
    BcInputSelectV2Behavior.prototype.setStatus = function (status) {
        this.clearStatus();
        if (status === 'disabled') {
            this.mySelf.classList.add(bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_INPUT_SELECT_V2_DISABLED);
            var placeholder = this.mySelf.querySelector(".".concat(bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_INPUT_SELECT_V2_PLACEHOLDER));
            placeholder.setAttribute('tabindex', '-1');
        }
        else if (status === 'error') {
            this.mySelf.classList.add(bc_input_select_v2_constants_1.BcInputSelect2Constants.BC_INPUT_SELECT_V2_ERROR);
        }
    };
    BcInputSelectV2Behavior.prototype.setSelectedValue = function (value) {
        if (value === null || value === undefined || value.trim() === '') {
            this.reset();
        }
        else {
            if (this.type === 'multiple') {
                this.changeValueMultiple(value);
            }
            else {
                this.changeValueSimple(value);
            }
        }
    };
    BcInputSelectV2Behavior.prototype.updateItems = function (items) {
        var isValid = items.length > 0 && items.every(function (item) { return 'label' in item && 'value' in item; });
        if (isValid) {
            this.itemsFloatMenu = items;
            this.updateListOptions();
        }
    };
    return BcInputSelectV2Behavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcInputSelectV2Behavior = BcInputSelectV2Behavior;
